<script>
import store from '../store/index.js';
import spec from './spec/index.vue';
import rpTips from './rpTips';
import price from './price';
import dealerActivity from '../dealerActivity';
import city from './city';
import dealer from './dealer';
import labelInput from './labelInput';
import formSubmit from './submit';
import statement from "./statement";
import recommendDialog from './recommendDialog';
import recommendSeries from './recommendSeries';
import success from './success';
import returnBlock from './returnBlock';

// import UI from '@/lib/ui.js';
import {alertMessage} from '@/lib/ui';
export default {
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            mobileConf: {
                id: 'mobile',
                label: '手机号：',
                maxLength: 11,
                placeholder: '请输入手机号',
                errMsg: '请输入正确格式的手机号',
                eye: true,
                tips: true,
                verify: {
                    change(val) {
                        return /^1\d{10}$/.test(val);
                    },
                    input(val) {
                        return /^\d{1,11}$/.test(val);
                    }
                }
            },
            nameConf: {
                id: 'name',
                label: '姓名：',
                maxLength: 10,
                placeholder: '如王先生、李女士',
                errMsg: '请输入您的姓名',
                verify: {
                    change(val) {
                        return val.trim() !== '';
                    }
                }
            },
            mobileSecret:'',
            isSecret:0
        }
    },
    computed: {
        mobile: {
            get() {
                return store.form.mobile;
            },
            set(val) {
                store.form.mobile = val;
            }
        },
        name: {
            get() {
                return store.form.name;
            },
            set(val) {
                store.form.name = val;
            }
        },
        testId() {
            return store.testId;
        },
        recommendSeriesFixedItems() {
            return store.recommendSeriesFixedItems;
        },
        returnBlockShow() {
            return store.returnBlockShow;
        }
    },
    watch: {
        mobileSecret: function (newVal) {
            if (newVal && newVal.indexOf('*') == -1) {
                store.form.mobile = newVal;
            }
        },
        returnBlockShow: function (val) {
            if (val) {
                this.$refs.returnBlock.show();
            }
        }
    },
    methods: {
        // 切换电话号码隐藏与否
        togglePhoneSecret: function () {
            let buttonId=''
            if (this.mobileSecret.indexOf('*') !== -1) {
                this.showPhoneNumber();
                buttonId = 'show'
            } else {
                this.mobileSecret = this.hidePhoneNumberMethod(this.mobile);
                this.isSecret = 1;
                buttonId = 'hide'
            }

            this.$clickMonitor.send({
				buttonId: "phone-click-"+buttonId,
				...store.getClickMonitorParams()
			});  
        },
        hidePhoneNumberMethod (phoneNumber) {
            return String(phoneNumber).split('').reduce(function(str, n, index) {
                str += index > 2 && index < 7 ? '*' : n;
                return str;
            }, '');
        },
        hidePhoneNumber: function () {
            var _this = this;
            setTimeout(function () {
                _this.mobileSecret = _this.hidePhoneNumberMethod(_this.mobile);
                _this.isSecret = 1;
            }, 200);
        },
        // 显示电话号码中间四位
        showPhoneNumber: function () {
            this.mobileSecret = this.mobile;
            this.isSecret = 0;
        },
        focusMobileInput: function () {
            this.showPhoneNumber();
        },
        clearMobile(){
            store.form.mobile = '';
        },
        clearName(){
            store.form.name = '';
        },
        check() {
            const mobileError = this.$refs.mobile.checkChange();
            const nameError = this.$refs.name.checkChange();
            // const dealerError = this.$refs.dealer.checkChange();
            return mobileError || nameError;
        },
        async submit(buttonId) {
            const isError = this.check();
            if (isError) {
                return;
            }
            this.$clickMonitor.send({
				buttonId: buttonId,
				...store.getClickMonitorParams()
			});  
            let alert = alertMessage('查询信息提交中…');
            const result = await store.submit(buttonId);
            alert.style.display = 'none';
            if (!result.status) {
                alertMessage(result.msg);
                return;
            }
            let arr = this.recommendSeriesFixedItems;
            for (var i=0; i<arr.length; i++) {
                if (arr[i].checked) {
                    var recResult = await store.submit('recommend_series_in_form', arr[i]);
                    if (!recResult.status) {
                        alertMessage(recResult.msg);
                        return;
                    }
                }
            }
            this.mobileSecret='';

            if(this.recommendSeriesFixedItems.length>0){
                this.$refs.recommend.show();
            }else{
                this.$refs.success.show();
            }
            
        },
        recommendDialogCancel(){
            var arr = this.recommendSeriesFixedItems.filter(item => {
                return item.checked == true;
            })
            if (arr.length >0) {
                this.$refs.success.show(3);
            } else {
                this.$refs.success.show(1);
            }
            this.$refs.recommend.hide();
        },
        recommendDialogSubmit(res){//推荐车系免费咨询
            if(res == 1){
                var data=[];
                this.recommendSeriesFixedItems.forEach(e => {
                    if (e.checked){
                        e.recoChecked = false;
                    }
                    e.recoChecked == true ? data.push(e) : '';
                })
                if(data.length>0 ){
                    for(var i=0;i<data.length;i++){
                        store.submit('lcy_recommend', data[i]);
                    }
                    this.$refs.recommend.hide();
                    this.$refs.success.show(2);
                }else{
                    this.$refs.recommend.hide();
                    this.$refs.success.show(1);
                }
            }else {
                this.$refs.recommend.hide();
                this.$refs.success.show(1);
            }
            
        },
        showSuccess() {
            this.$refs.returnBlock.hide();
            this.$refs.success.show(4);
        }
    },
    mounted() {
        this.$eventBus.$on('toSubmit', (buttonId) => {
            this.submit(buttonId);
        });
        this.hidePhoneNumber();
        // this.$refs.success.show(1);
        // this.$refs.recommend.show();
        // if (this.testId == '2020092201') {
            // this.$refs.returnBlock.show();
        // }
    },
    components: {
        spec,
        rpTips,
        price,
        dealerActivity,
        city,
        labelInput,
        dealer,
        recommendSeries,
        formSubmit,
        statement,
        success,
        recommendDialog,
        returnBlock
    }
}
</script>

<template>
    <div id="form" class="form-wrap">
        <div class="form-inner">
            <spec></spec>
            <rp-tips></rp-tips>
            <price></price>
            <dealer-activity></dealer-activity>
            <city></city>
            <label-input ref="name" :params="nameConf" v-model="name" @clear="clearName"></label-input>
            <label-input ref="mobile" :params="mobileConf" @focusMobileInput="focusMobileInput" @clear="clearMobile" :isSecret="isSecret" @hidePhoneNumber="hidePhoneNumber" @togglePhoneSecret="togglePhoneSecret" v-model="mobileSecret"></label-input>
            <!-- <label-input v-else ref="mobile" :params="mobileConf"  @clear="clearMobile" v-model="mobile"></label-input> -->
            <!-- <dealer ref="dealer"></dealer> -->
            <recommend-series></recommend-series>
            <form-submit @click="submit($event)"></form-submit>
            <statement></statement>
            <recommend-dialog ref="recommend" @cancel="recommendDialogCancel" @recommendDialogSubmit="recommendDialogSubmit"></recommend-dialog>
            <success ref="success" v-if="load"></success>
            <return-block ref="returnBlock" @showSuccess= "showSuccess"></return-block>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.form-wrap
    position relative
    margin .96rem 0.8rem 0
    // padding 0.32rem
    border-radius 0.213rem
    // background-color #e7d1ff
.form-top-symbol
    position absolute
    top -12px
    left 0
    right 0
    margin auto
    width 16.26rem
    text-align center
    font-size 0
    .symbol-back
        position absolute
        top 6px
        width 100%
        height 12px
        border-radius 6px
        background-color rgba(231, 209, 255, .53)
    .symbol-front
        display inline-block
.form-inner
    padding 0 1.173rem
    border-radius 0.213rem
    background-color #ffF
    overflow hidden
</style>
